import React from "react";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Button, Drawer, Form, Input, Space, Typography } from "@payping/web-components";
import { DashboardChecksTypeEnum } from "@payping/api";
import { Close } from "@payping/icons";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { DashboardRoutes } from "@/router/constant";
import { useHandleNavigationURL, useSaveToRedux } from "@/mobile/Settings/Business/utils";
import { settingsBusinessAtom } from "@/mobile/Settings/state";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";

const mobileFormEditAtom = selectAtom(settingsBusinessAtom, (val) => val.mobileFormEdit);

const MobileEditOfficialBusinessEconomicCode: React.FC = () => {
  const { t } = useAppTranslation();
  const [form] = Form.useForm();
  const checks = useAppSelector((state) => state.user.checks);
  const isBusinessDisabled = checks?.businessStatus === DashboardChecksTypeEnum.Confirmed;
  const [mobileFormEditState] = useAtom(mobileFormEditAtom);

  const economicCodeApi = useAppSelector((state) => state.user.businessInfo?.economicCode);

  // Custom Hooks
  const { saveToRedux } = useSaveToRedux();
  const { handleNavigationURL } = useHandleNavigationURL();

  return (
    <>
      <Drawer
        placement={"bottom"}
        open={true}
        height={"100%"}
        title={`${t("edit")} / ${t("settings.business.economicCode")}`}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
        footer={<EditActionButtons onAccept={form.submit} acceptText={t("next")} />}
      >
        <Space direction={"vertical"}>
          <Form
            onFinish={({ economicCode }) =>
              saveToRedux({
                nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditBusiness.officialBusinessDocument.url,
                nextUrlForEdit: DashboardRoutes.settings.mEditBusiness.officialBusinessDocument.url,
                fieldName: "economicCode",
                fieldValue: economicCode,
                setIsDrawerOpen: () => {},
              })
            }
            form={form}
            initialValues={{ economicCode: mobileFormEditState.economicCode ?? economicCodeApi }}
          >
            <Form.Item label={t("settings.business.economicCode")} name="economicCode">
              <Input
                disabled={!form.getFieldValue("economicCode") ? false : isBusinessDisabled}
                onlyNumbers
                canStartWithZero
              />
            </Form.Item>
          </Form>
          <Typography.Text type={"secondary"}>{t("mobileEditPersonal.nameDesc")}</Typography.Text>
        </Space>
      </Drawer>
    </>
  );
};

export default MobileEditOfficialBusinessEconomicCode;
